import { useState } from 'react';
import { toast } from 'sonner';
import { Mic } from 'lucide-react';
import { getA11y, listenCommand, speak } from '../lib/a11y';
import { buzz } from '../lib/glove';

// voice command while drawing: "Punkt", "Rückgängig", "Fertig", "Abbrechen" (only when switched on)
export default function VoiceCmd({ t, net }) {
  const [busy, setBusy] = useState(false);
  const d = net.draft;
  if (!d || !getA11y().voice || (d.kind !== 'pipe' && d.kind !== 'fitting')) return null;
  const run = async () => {
    setBusy(true);
    const c = await listenCommand();
    setBusy(false);
    const cur = net.draftRef?.current || d;
    if (c === 'point') net.addAtCrosshair();
    else if (c === 'undo' && cur.points?.length) net.setDraft({ ...cur, points: cur.points.slice(0, -1) });
    else if (c === 'finish') { if (cur.kind === 'pipe') net.finishPipe(); else net.setDraft(null); }
    else if (c === 'cancel') net.cancelDraft();
    else { toast.message(t.vcNone); return; }
    buzz(40); speak(t['vc_' + c]);
  };
  return (
    <button className={`voice-cmd mask ${busy ? 'on' : ''}`} data-testid="voice-cmd-btn" onClick={run} title={t.vcHint} aria-label={t.vcHint}>
      <Mic size={22} />
    </button>
  );
}
